<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-bell</v-icon>
        <v-toolbar-title>System Configuration - Announcements</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'system-configuration-announcements-toolbar',
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>